import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onMarkAsRead, onArchive, onDelete, onCancel }) => {
  return (
    <div className="bg-primary text-primary-foreground rounded-xl p-4 mb-6 shadow-lg">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Icon name="CheckSquare" size={20} />
          <span className="font-semibold">{selectedCount} notification(s) selected</span>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="secondary"
            size="sm"
            onClick={onMarkAsRead}
          >
            <Icon name="Check" size={14} className="mr-1" />
            Mark as Read
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={onArchive}
          >
            <Icon name="Archive" size={14} className="mr-1" />
            Archive
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
          >
            <Icon name="Trash2" size={14} className="mr-1" />
            Delete
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onCancel}
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <Icon name="X" size={14} className="mr-1" />
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;